import styled from 'styled-components'
import BackButton from 'modules/shares/components/BackButton'

/** We are using multiple overlays on top of the canvas */
const zIndex = {
  canvasStatus: 1,
  betaTooltip: 1,
  // back button should appear on top of web-renderer
  // overlay loading screen
  backButton: 2,
}

export const StyledPageCanvas = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  /*
   * Some versions of safari ignore height: 100% in some flexbox context.
   * So we use flex-grow:1 to force the element to take all the available space.
   */
  flex-grow: 1;
  /*
   * Continue propagation of flex flow to the child canvas
   * so that the height of the canvas is automatically 100% of the parent.
   https://github.com/sketch-hq/Cloud/issues/10223
   */
  display: flex;
`

export const StyledWebRendererStatusContainer = styled.div`
  position: absolute;
  z-index: ${zIndex.canvasStatus};
  background-color: ${({ theme }) => theme.colors.background.light.secondary};
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
  align-self: center;
  justify-content: center;
`

export const StyledWebRendererFeaturePreviewContainer = styled.div`
  position: absolute;
  z-index: ${zIndex.betaTooltip};
  left: 16px;
  bottom: 16px;
  pointer-events: auto;
`

export const StyledBackButton = styled(BackButton)`
  position: absolute;
  z-index: ${zIndex.backButton};
  top: 18px;
  left: 17px;
`
